import { PopupManager } from 'element-ui/lib/utils/popup';
class GlobalTooltip {
    constructor(id = 'sequence-tooltip-singleton') {
        this.containerDom = document.getElementById(id) || document.createElement('div');
        this.containerDom.setAttribute('id', id);
        const style = `position: fixed;
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
            border-radius: 4px;
            border: 1px solid #DFE1E6;
            z-index: 5001;`;
        this.containerDom.setAttribute('style', style);
        this.target = null;
        this.visible = false;
        this.hideTimeout = null;
        window.document.body.appendChild(this.containerDom);
        this.containerDom.addEventListener('mousemove', () => {
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
            }
        });
        this.containerDom.addEventListener('mouseleave', () => {
            this.hide();
        });
        document.body.addEventListener('click', (e) => {
            if (this.containerDom.contains(e.target)) {
                return;
            }
            this.hide();
        });
    }
    show(content, x, y, target) {
        if (!this.containerDom) {
            return;
        }
        if (this.visible && this.target === target) {
            return;
        }
        this.containerDom.innerHTML = '';
        if (typeof content === 'string') {
            this.containerDom.innerHTML = content;
        }
        else {
            this.containerDom.appendChild(content);
        }
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
        }
        this.containerDom.style.display = 'block';
        const location = this.updateLocation(x, y);
        this.containerDom.style.left = `${location.x}px`;
        this.containerDom.style.top = `${location.y}px`;
        this.containerDom.style.zIndex = PopupManager.nextZIndex();
        this.visible = true;
        this.target = target;
    }
    hide() {
        if (!this.containerDom) {
            return;
        }
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
        }
        this.hideTimeout = setTimeout(() => {
            this.containerDom.style.display = 'none';
            this.visible = false;
        }, 600);
    }
    updateLocation(x, y) {
        let lastX = x + 8;
        let lastY = y - 10;
        const { clientWidth, clientHeight } = this.containerDom;
        const wh = window.innerHeight;
        const ww = window.innerWidth;
        // 计算弹框是否超出屏幕
        const dx = clientWidth + lastX - ww;
        if (dx > 0) {
            // 尝试左移动
            const tempX = lastX - dx;
            if (tempX > 0) {
                lastX = tempX;
            }
        }
        // 如果出现遮挡target 尝试下移
        const isCoverTarget = x > lastX;
        if (isCoverTarget) {
            lastY += 20;
        }
        // 判断是否触到底边
        if (clientHeight + lastY > wh) {
            let tempY = y - clientHeight + 5;
            if (isCoverTarget) {
                tempY -= 25;
            }
            if (tempY > 0) {
                lastY = tempY;
            }
        }
        return {
            x: lastX,
            y: lastY,
        };
    }
}
let globalTooltip;
export function getGlobalTooltip(id) {
    if (!globalTooltip) {
        globalTooltip = new GlobalTooltip(id);
    }
    return globalTooltip;
}
//# sourceMappingURL=bioTooltipSingleton.js.map